module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/case-study-events-fbfd60cd6dc1c47c82c08fc2df07e955.jpg";